
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/token-town/slugPages/draw",
      function () {
        return require("private-next-pages/token-town/slugPages/draw.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/token-town/slugPages/draw"])
      });
    }
  